import React from "react";

const Logo = () => {
  return (
    <svg
      width="138px"
      height="38px"
      viewBox="0 0 138 38"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group 9</title>
      <defs>
        <linearGradient
          x1="22.046019%"
          y1="0%"
          x2="100%"
          y2="100%"
          id="linearGradient-1"
        >
          <stop stopColor="#186BFE" offset="0%"></stop>
          <stop stopColor="#0B3B96" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="Kanban-Dashboard-UI"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Tasks" transform="translate(-18.000000, -35.000000)">
          <g id="Group-9" transform="translate(18.000000, 35.500000)">
            <g
              id="logp"
              transform="translate(34.000000, 1.500000)"
              fill="#FFFFFF"
              fontFamily="Arial"
              fontSize="20"
              fontWeight="bold"
            >
              <text id="Methodize.">
                <tspan x="0" y="21">
                  PMS
                </tspan>
              </text>
            </g>
            <circle
              id="Oval"
              fill="url(#linearGradient-1)"
              cx="9"
              cy="21"
              r="9"
            ></circle>
            <circle
              id="Oval"
              fill="url(#linearGradient-1)"
              cx="18"
              cy="6"
              r="6"
            ></circle>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Logo;
